<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">编辑门店</span>
    </h2>
    <breadcrumb firstName="门店管理"></breadcrumb>
    <shop-content :type="3" ref="shopContent"></shop-content>
  </div>
</template>
<script>
import breadcrumb from '@/components/global/breadcrumb';
import shopContent from '@/components/shopManagement/content.vue';
import contentMix from './mixins/shopContent';

export default {
  components: {
    breadcrumb,
    shopContent
  },
  mixins: [contentMix]
};
</script>
